export default __webpack_public_path__ + "static/media/placeholder_dummy2016-steuerberatung01-de.8fbf4449.png";